/* Landing-page conversion tracking (public, no auth required).
 *
 * Fires against `POST /api/analytics/landing-event`. The endpoint is
 * rate-limited server-side + silent-success by design so a network
 * failure never affects the visitor experience.
 *
 * Preferred transport is `navigator.sendBeacon` so the request
 * survives page unload (click-then-navigate). Falls back to `fetch`
 * with `keepalive: true` for browsers/paths where sendBeacon isn't
 * available.
 */

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';

function currentPath() {
  try { return window.location.pathname + window.location.search; }
  catch { return ''; }
}

function safeReferrer() {
  try { return document.referrer || ''; }
  catch { return ''; }
}

/** Fire a landing-page analytics event. Never throws. */
export function trackLandingEvent(event, meta = undefined) {
  if (!event) return;
  const body = JSON.stringify({
    event,
    path:     currentPath(),
    referrer: safeReferrer(),
    meta:     meta || undefined,
  });
  const url = `${API}/analytics/landing-event`;
  try {
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      const ok = navigator.sendBeacon(url, blob);
      if (ok) return;
    }
  } catch { /* fall through to fetch */ }
  try {
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      credentials: 'omit',
      keepalive: true,
    }).catch(() => { /* silent */ });
  } catch { /* silent */ }
}
